import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  configs: [],
  pages: [],
  pageContents: {},
  locales: {},
  schemas: null,
  page: null,
  pageRecord: null,
  selectedPath: null,
  hoveredPath: null,
  viewport: 'desktop',
  ready: false,
  pageLoaded: false,
  saving: false,
  canSave: true,
  error: null,
  setupError: null,
};

export const editorSlice = createSlice({
  name: 'storefrontEditor',
  initialState,
  reducers: {
    setup(state, { payload }) {
      Object.assign(state, initialState, payload);
    },

    loadPage(state, { payload }) {
      state.page = payload.page;
      state.pageRecord = payload.pageRecord;
      state.selectedPath = null;
      state.hoveredPath = null;
      state.error = null;
    },

    setPageRecord(state, { payload }) {
      state.pageRecord = payload;
    },

    setPageContent(state, { payload }) {
      state.pageContents[payload.pageId] = {
        content: payload.content,
        pageMeta: payload.pageMeta,
      };
    },

    replaceConfig(state, { payload }) {
      const index = state.configs.findIndex(
        (config) => config.id === payload.id,
      );
      if (index >= 0) {
        state.configs[index] = payload;
      } else {
        state.configs.push(payload);
      }
    },

    setLocales(state, { payload }) {
      state.locales = payload;
    },

    appReady(state, { payload }) {
      state.schemas = payload.schemas;
      state.ready = true;
    },

    appRendered(state) {
      state.pageLoaded = true;
    },

    setSelectedPath(state, { payload }) {
      state.selectedPath = payload;
    },

    setHoveredPath(state, { payload }) {
      state.hoveredPath = payload;
    },

    setViewport(state, { payload }) {
      state.viewport = payload;
    },

    setSaving(state, { payload }) {
      state.saving = payload;
    },

    setCanSave(state, { payload }) {
      state.canSave = payload;
    },

    setError(state, { payload }) {
      state.error = payload;
    },

    setSetupError(state, { payload }) {
      state.setupError = payload;
    },
  },
});
